import { useStore } from '@xyflow/react';

export function useGetHandleClasses() {
  const nodes = useStore((state) => state.nodes);
  const edges = useStore((state) => state.edges);

  const selectedNodes = nodes.filter((node) => node.selected);
  const selectedEdges = edges.filter((edge) => edge.selected);

  const highlightedEdges = edges.filter((edge) => {
    const selectedNodeIds = selectedNodes.map((node) => node.id);
    return selectedNodeIds.some(
      (nodeId) => edge.source === nodeId || edge.target === nodeId
    );
  });

  const getHandleState = (handleId: string, type: 'source' | 'target') => {
    const isConnected = edges.some((edge) =>
      type === 'source'
        ? edge.sourceHandle === handleId
        : edge.targetHandle === handleId
    );

    const isSelected = selectedEdges.some((edge) =>
      type === 'source'
        ? edge.sourceHandle === handleId
        : edge.targetHandle === handleId
    );

    const isHighlighted = highlightedEdges.some((edge) =>
      type === 'source'
        ? edge.sourceHandle === handleId
        : edge.targetHandle === handleId
    );

    return {
      connected: isConnected,
      selected: isSelected,
      highlighted: isHighlighted,
    };
  };

  const getHandleClasses = (handleId: string, type: 'source' | 'target') => {
    const state = getHandleState(handleId, type);
    const baseClass =
      type === 'source'
        ? 'react-flow__handle-link-source'
        : 'react-flow__handle-link-target';
    const classes = [baseClass];

    if (state.connected) classes.push('connected');
    if (state.selected) classes.push('selected');
    if (state.highlighted) classes.push('highlighted');

    return classes.join(' ');
  };

  return { getHandleClasses };
}
